import React from "react";
import { getValue } from "@utils/lodash";

function LogSubheaderSvgComponent(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" 
      height={
        getValue(props, `size`, "") ? getValue(props, `size`, "") : "24px"
      }
      width={
        getValue(props, `size`, "") ? getValue(props, `size`, "") : "24px"
      }
      viewBox="0 0 24 24">
      <defs>
        <clipPath id="clip-path-log">
          <rect id="Rectangle_18193" data-name="Rectangle 18193" width="24" height="24" transform="translate(-14685 -8272)" fill="#fff"/>
        </clipPath>
      </defs>
      <g id="Mask_Group_301" data-name="Mask Group 301" transform="translate(14685 8272)" clip-path="url(#clip-path-log)">
        <path id="task_FILL0_wght300_GRAD0_opsz24_1_" data-name="task_FILL0_wght300_GRAD0_opsz24 (1)" d="M12.564-11.439l5.657-5.583-1.157-1.142-4.517,4.457-2.261-2.231-1.14,1.125ZM7.612-7.158a1.874,1.874,0,0,1-1.368-.553,1.825,1.825,0,0,1-.56-1.35V-25.255a1.825,1.825,0,0,1,.56-1.35,1.874,1.874,0,0,1,1.368-.553h8.472l5.6,5.526V-9.061a1.825,1.825,0,0,1-.56,1.35,1.874,1.874,0,0,1-1.368.553H7.612Zm7.672-13.684v-4.737H7.612a.316.316,0,0,0-.226.1.308.308,0,0,0-.1.223V-9.061a.308.308,0,0,0,.1.223.316.316,0,0,0,.226.1H19.756a.316.316,0,0,0,.226-.1.308.308,0,0,0,.1-.223V-20.842Zm-8-4.737v0Z" transform="translate(-14686.685 -8242.842)" fill={
          getValue(props, `color`, "")
            ? getValue(props, `color`, "")
            : "#5f6368"
        } />
      </g>
      </svg>
  );
}

export default LogSubheaderSvgComponent;
